import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { Labeled, SimpleShowLayout, TextField, DateField, useDataProvider } from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { studentRequests } from "api/studentApi";
import ImagePreview from "components/Alumni/AlumniEvents/ImagePreview";
import { DocumentsType } from "utils/constants";
import AddPersonalDocumentsPhotoModal from "components/Users/Students/Modals/AddPersonalDocumentsPhotoModal";
import EditPersonalDocumentsDataModal from "components/Users/Students/Modals/EditPersonalDocumentsDataModal";
import DeletePersonalDocumentsPhotoModal from "components/Users/Students/Modals/DeletePersonalDocumentsPhotoModal";
import { useCallback, useEffect, useState } from "react";
import { useNotifyError } from "utils/useNotifyError";

const PersonalDocumentsData = ({ record }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const dataProvider = useDataProvider();
  const notifyError = useNotifyError();
  const [data, setData] = useState(null);

  const fetchData = useCallback(async () => {
    if (!record?.studentId) return;
    try {
      const res = await dataProvider.customRequest(studentRequests.getStudentPersonalDocuments(record?.studentId));
      setData(res.data);
    } catch (error) {
      notifyError(error);
    }
  }, [record?.studentId, dataProvider, notifyError]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <SimpleShowLayout>
      <Grid
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Accordion sx={{ width: "100%" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
            <Typography
              color={"#4E2683"}
              sx={{ fontWeight: "bold" }}
            >
              Данни за лични документи
            </Typography>
          </AccordionSummary>{" "}
          <AccordionDetails sx={{ width: "100%" }}>
            {data?.length > 0 ? (
              data?.map((document, idx) => (
                <Grid
                  key={`${document.id}-${idx}`}
                  spacing={2}
                  gap={6}
                  container
                  sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
                >
                  <Grid
                    item
                    xs={12}
                    md={4}
                    xl={2}
                  >
                    <Labeled label="Номер на документ">
                      <TextField
                        record={document}
                        source="number"
                        emptyText="-"
                      />
                    </Labeled>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    xl={2}
                  >
                    <Labeled label="Валиден до">
                      <DateField
                        record={document}
                        source="validUntil"
                        locales="bg-BG"
                      />
                    </Labeled>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <SecuredComponent permission={permissions.canManageStudentPrersonalDocuments}>
                      <EditPersonalDocumentsDataModal
                        record={document}
                        studentId={record?.studentId}
                        id={document?.id}
                        fetchData={fetchData}
                      />
                    </SecuredComponent>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                  >
                    <Labeled
                      label="Снимка предна част"
                      pr={6}
                    >
                      {document?.frontDocumentId ? (
                        <ImagePreview
                          id={document?.frontDocumentId}
                          type={DocumentsType.PRIVATE}
                        />
                      ) : (
                        <Typography
                          py={3}
                          sx={{ fontSize: "12px" }}
                        >
                          Няма качена снимка
                        </Typography>
                      )}
                    </Labeled>

                    {document?.frontDocumentId ? (
                      <SecuredComponent permission={permissions.canManageStudentPrersonalDocuments}>
                        <DeletePersonalDocumentsPhotoModal
                          studentId={record?.studentId}
                          id={document?.id}
                          side={0}
                          fetchData={fetchData}
                        />
                      </SecuredComponent>
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                  >
                    <Labeled
                      label="Снимка - гръб"
                      pr={6}
                    >
                      {document?.backDocumentId ? (
                        <ImagePreview
                          id={document?.backDocumentId}
                          type={DocumentsType.PRIVATE}
                        />
                      ) : (
                        <Typography
                          py={3}
                          sx={{ fontSize: "12px" }}
                        >
                          Няма качена снимка
                        </Typography>
                      )}
                    </Labeled>

                    {document?.backDocumentId ? (
                      <SecuredComponent permission={permissions.canManageStudentPrersonalDocuments}>
                        <DeletePersonalDocumentsPhotoModal
                          studentId={record?.studentId}
                          id={document?.id}
                          side={1}
                          fetchData={fetchData}
                        />
                      </SecuredComponent>
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <SecuredComponent permission={permissions.canManageStudentPrersonalDocuments}>
                      <AddPersonalDocumentsPhotoModal
                        studentId={record?.studentId}
                        id={document?.id}
                        fetchData={fetchData}
                      />
                    </SecuredComponent>
                  </Grid>
                </Grid>
              ))
            ) : (
              <Grid
                spacing={2}
                gap={6}
                container
                sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
              >
                <Grid item>
                  <Typography
                    variant="body2"
                    fontSize={"12px"}
                  >
                    Няма прикачени документи
                  </Typography>
                </Grid>
              </Grid>
            )}
          </AccordionDetails>
        </Accordion>
      </Grid>
    </SimpleShowLayout>
  );
};
export default PersonalDocumentsData;
